import { useTranslation } from '@mint-lib/i18n';
import { Button } from '@mint-lib/tw-components';

export const BackButton = ({
  onClick,
  disabled,
}: {
  onClick: () => void;
  disabled?: boolean;
}) => {
  const { t } = useTranslation('@myn/import-hub');

  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      variant="text"
      data-dd-action-name="Previous"
    >
      {t('Previous')}
    </Button>
  );
};
